import { Injectable, Inject } from "@angular/core";
import { AuthHttp } from "angular2-jwt";
import { APIBase } from "./api.base";
import { Router } from "@angular/router";
import { SessionStorageService } from "../services/session-storage.service";

@Injectable()
export class UsersAPI extends APIBase {
  constructor(
    @Inject(AuthHttp) authHttp: AuthHttp,
    @Inject(Router) router: Router,
    @Inject(SessionStorageService) session: SessionStorageService
  ) {
    super(authHttp, router, session);

    // Entidade principal
    this.__entity = "users";
  }

  public contact(data) {
    return this._call(this.__entity + "/contact", data);
  }

  async forgetPassword(email) {
    return this._call(this.__entity + "/forgot_password", { Email: email });
  }

  public getSupervisorCandiates(data) {
    let hasName = {};
    if (data) {
      hasName = { Nome_like: data };
    }
    return this._call(`${this.__entity}/supervisors`, hasName, "get");
  }

  public getByUserName(data) {
    let hasName = {};
    if (data) {
      hasName = { Nome_like: data };
    }
    return this._call(this.__entity, hasName, "get");
  }

  public login(user) {
    return this._call(this.__entity + "/login", user);
  }

  public logout() {
    return this._call(this.__entity + "/logout", {});
  }

  public loginToken(token) {
    return this._call(this.__entity + "/login_token", token);
  }

  async updateUser(user) {
    return this._call(this.__entity + "/updateUser", user);
  }

  async validadeHash(data) {
    return this._call(this.__entity + "/validate_hash", data);
  }

  async getPartnerLink(id: string) {
    return this._call(`${this.__entity}/partner/link`, { id }, "get");
  }

  public loginKey(key) {
    return this._call(`${this.__entity}/login_key/${key}`, null);
  }
}



// WEBPACK FOOTER //
// ./src/api/users.api.ts